import * as React from "react";
import { useState } from "react";
import { TurnrButton } from "./TurnrButton";
import { TurnrConfirmSaveModal } from "../modals/TurnrConfirmModal.jsx";

export default function TurnrConfirmSaveModalButton(props) {
    const { appProps, serviceData, onSuccess, onError, successTitle, errorTitle, open, setOpen, ...rest } = props;

    const [modalOpenLocal, setModalOpenLocal] = useState(false);

    const modalOpen = open === undefined ? modalOpenLocal : open;

    const setModalOpen = setOpen || setModalOpenLocal;

    return (
        <>
            <TurnrConfirmSaveModal
                appProps={appProps}
                serviceData={serviceData}
                onSuccess={onSuccess}
                onError={onError}
                successTitle={successTitle}
                errorTitle={errorTitle}
                open={modalOpen}
                onClose={setModalOpen}
                {...props}
            />
            <TurnrButton
                appProps={appProps}
                {...rest}
                onClick={(e) => {
                    e.stopPropagation();
                    setModalOpen(true);
                }}
            />
        </>
    );
}
